import * as Sentry from "@sentry/react";
import React, { useEffect, useState, useContext } from "react";
import ReactDOM from "react-dom/client";
import { TourProvider } from '@reactour/tour'
import { Route, Switch, Router, useLocation, Link } from "wouter";
import axios from "axios";
import Swal from "sweetalert2";

import "./index.css";
import Root from "./routes/root";
import Login from "./routes/login";
import ConsultalaLogin from "./routes/consultala_login";
import Recover from "./routes/recover";
import Signup from "./routes/signup";
import Registrazione from "./routes/registrazione";
import ErrorPage from "./error-page";
import { AuthContext } from './contexts/auth'
import { DataContext } from "./contexts/data";
import MessageProvider from "./contexts/message";
import ResourceList from "./routes/resource_list";
import ResourceDetail from "./routes/resource_detail";
import Employee from "./routes/employee";
import ComingSoon from "./routes/coming_soon";
import EmployeeList from "./routes/employee_list";
import NewEmployee from "./routes/new_employee";
import CostoLavoro from "./routes/calcolo_costo_lavoro";

import Livelli from "./routes/livelli";
import Register from "./routes/register";
import UploadSingleBusta from "./routes/upload_single_busta";
import UploadSingleCu from "./routes/upload_single_cu";
import UploadSingleDoc from "./routes/upload_single_doc";
import Profile from "./routes/profile";
import EditEmployee from "./routes/edit_employee";
import ProfileBilling from "./routes/profile_billing";
import UploadCSVEmployee from "./routes/upload_csv_employee";

import { useAtom } from 'jotai';
// import { StoreProvider } from 'easy-peasy';

import { currentUserStore, isEmployeeStore, jwtStore, profileStore } from "./stores/mainStore";
import AuthenticatedRoute from "./layouts/AuthenticatedRoute";
import UnauthenticatedRoute from "./layouts/UnauthenticatedRoute";
import { OrgTree } from "./routes/org_tree";
import { CreateOrgUnitForm } from "./routes/org_create";
import { Presence } from "./routes/presence";
import { PendingJustifications } from "./routes/pending_justifications";
import { HandledJustifications } from "./routes/handled_justifications";
import BoardMessage from "./routes/notice_board";
import ConfigurazioneParametri from "./routes/settings_ratei"
import ShiftManagement from "./routes/shift_management"
import GiustificativiView from "./routes/giustificativi_table";
import ShiftCalendar from "./routes/shift_calendar";
import DetailOrgUnit from "./routes/org_unit_detail";
import { OrgEdit } from "./routes/org_edit";
import TableAssignWh from "./components/table_assign_working_hour";
import { NewJustificationRequest } from "./routes/new_justification_request";

import ArCedolini from './routes/areariservata/cedolini'
import ArCu from './routes/areariservata/cu'
import ArSingleCedolino from './routes/areariservata/single_cedolino'
import Dashboard from "./routes/dashboard";
import ArSingleCu from "./routes/areariservata/single_cu";
import ArDocuments from "./routes/areariservata/documents";
import ArTurni from "./routes/areariservata/turni";
import ArNewJustificationRequest from "./routes/areariservata/ar_new_justification_request";
import ProfileEmployee from "./routes/areariservata/profile";
import ArSingleMessage from "./routes/areariservata/single_message";
import ArSingleDoc from "./routes/areariservata/single_doc";
import EmployeeDetails from "./components/employee_details";
import AvvisiComponent from "./routes/areariservata/avvisi";
import RimborsoSpese from "./routes/areariservata/rimborso_spese";
import RimborsoSpeseCompany from "./routes/refund_requests";
import NotAuthorized from "./authorization/NotAuthorized";
import CheckPermissions from "./components/check_permissions";
import NoPermissions from "./authorization/NoPermissions";
import TimbratureDipendente from "./routes/areariservata/timbrature";
import TimbratureCompanyView from "./routes/in_outs";
import Statistics from "./routes/statistiche";
import { hasPermission } from "./utils";

if(document.location.href.includes('aziende.consultala.com')) {
  window.console.log = () => {}
}


function App() {
  const [userName, setUserName] = useAtom(currentUserStore);
  const [token, setToken] = useAtom(jwtStore);
  const [profile, setProfile] = useAtom(profileStore);
  const [isEmployee, setIsEmployee] = useAtom(isEmployeeStore);

  const [isLoading, setIsLoading] = useState(true);

  const [bustePagaGlobal, setBustePagaGlobal] = React.useState([])
  const [dipendentiGlobal, setDipendentiGlobal] = React.useState([])
  const [cuGlobal, setCuGlobal] = React.useState([])
  const [documentiGlobal, setDocumentiGlobal] = React.useState([])
  const [location, setLocation] = useLocation();
  const [showNotAuthorized, setShowNotAuthorized] = useState(false);

  const hasConsultalaHRPro = profile && profile.level && profile.level.hasOwnProperty("consultala_hr_pro");

  const superEmails = [
    'micheledepaolis@studiodepaolis.org' 
    , 'chiara.lucia@consultala.com' 
    , 'admin@consultala.com' 
    , 'giova.panasiti@gmail.com'
    ,'matteo@barisoft.it'
  ]; 
  const isSuperUser = profile && superEmails.includes(profile.the_real_user_email);
  const canAccessLivelli = (profile.customer_type !== 'employee');

  useEffect(() => {
    if (profile && profile.employee && profile.employee.permissions) {
      console.log("Permissions loaded");
    } else {
      console.log("Permissions not yet loaded or unavailable");
    }
  }, [profile]);

  useEffect(() => {
    if (token !== undefined) {
      setIsLoading(false);
    }
  }, [token]);

  const handlePaymentRequired = () => {
    Swal.fire({
      icon: "error",
      title: "Sottoscrizione richiesta",
      html: `
        Devi effettuare la sottoscrizione ad un piano di abbonamento per utilizzare la risorsa richiesta.</br></br> 
        Scopri le nuove funzionalità di Consultala HR cliccando 
        <b style="color: #4338ca; text-decoration: underline;">
          <a href="https://consultalahr.com/" target="_blank" style="color: inherit; text-decoration: inherit;">
            qui
          </a>
        </b>.
      `,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: 'Vai ai piani'
    }).then(() => {
      setLocation("/livelli");
    });
  };

  const handleForbidden = () => {
    Swal.fire({
      icon: "warning",
      title: "Accesso Negato",
      text: "Non hai i permessi per visualizzare questa risorsa",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(() => {
      setLocation("/");
    });
  };

  const handleUnauthorized = () => {
    Swal.fire({
      icon: 'warning',
      title: 'Sottoscrizione richiesta',
      text: 'La funzionalità selezionata è inclusa nel piano di abbonamento HR Pro.',
      confirmButtonText: 'Vai ai piani di abbonamento',
      showCancelButton: true,
      cancelButtonText: 'Chiudi',
      backdrop: `rgba(0, 0, 0, 0.8) url('') center center / cover no-repeat`,
      customClass: {
        popup: 'swal2-blur',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href = "/livelli";
      } else {
        setLocation('/');
      }
    });
  };

  axios.interceptors.request.use(
    (config) => {
      const profile = JSON.parse(localStorage.getItem('profile') || '{}');
      const permission = config.permission;

      if (permission && (!profile || !hasPermission(permission, profile))) {
        console.warn(`Accesso negato: permessi insufficienti ${config.url}`);

        const url = new URL(config.url);
        url.pathname = '/api/livelli';


        return {
          headers: config.headers,
          method: 'GET',
          url: url.toString()
        };
      }
  
      return config;
    },
    (error) => Promise.reject(error)
  );

  // axios.interceptors.request.use(
  //   (config) => {
  //     const profile = JSON.parse(localStorage.getItem("profile") || "{}");
  //     const permission = config.permission;
  
  //     if (permission && (!profile || !hasPermission(permission, profile))) {
  //       console.warn(`Accesso negato: permessi insufficienti ${config.url}`);
        
  //       return Promise.reject(new axios.Cancel(`Accesso negato: permessi insufficienti per ${config.url}`));
  //     }
  
  //     return config;
  //   },
  //   (error) => Promise.reject(error)
  // );
  

  // axios.interceptors.response.use(
  //   (response) => {
  //     setShowNotAuthorized(false);
  //     return response;
  //   },
  //   (error) => {
  //     if (error.response) {
  //       const { status } = error.response;
        
  //       if (status === 403) {
  //         // console.error("Errore 403: Accesso non autorizzato");
  //         handleForbidden();
  //       } else if (status === 402) {
  //         // console.error("Errore 402: Pagamento richiesto");
  //         handlePaymentRequired();
  //       } else {
  //         console.error(`Errore Axios: ${status}`);
  //       }
  //     } else {
  //       // console.error("Errore di rete o problema sconosciuto", error);
  //     }

  //     return Promise.reject(error);
  //   }
  // );


  
  const signOut = (withRedirect = true) => {
    setUserName("");
    setToken("");
    setProfile("");
    setIsEmployee(false);
    if (withRedirect) {
      setLocation("/login");
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <AuthContext.Provider
        value={{ userName, setUserName, setToken, profile, setProfile, token, signOut, isEmployee, setIsEmployee}}
      >
        <DataContext.Provider 
          value={{bustePagaGlobal, setBustePagaGlobal, dipendentiGlobal, setDipendentiGlobal, cuGlobal, setCuGlobal, documentiGlobal, setDocumentiGlobal}} >
          <MessageProvider>
            <TourProvider 
              steps={[]}
              onClickMask={({ setCurrentStep, currentStep, steps, setIsOpen }) => {
                if (steps) {
                  if (currentStep === steps.length - 1) {
                    setIsOpen(false)
                  }
                  setCurrentStep((s) => (s === steps.length - 1 ? 0 : s + 1))
                }
              }}>
              {/* {token ? <RouterProvider router={router} /> : <RouterProvider router={routerUnAuth} />} */}
              <Switch>

                {/*
                  ************************************
                  BASE
                  ************************************
                */}
                <AuthenticatedRoute 
                  path="/" 
                  permission='payrolls' 
                  component={Dashboard} />
                
                <AuthenticatedRoute
                  path="/calcolo_costo_lavoro"
                  permission='payrolls'
                  component={CostoLavoro} />
                
                <AuthenticatedRoute
                  path="/calcolo_costo_lavoro"
                  permission='payrolls'
                  component={CostoLavoro} />
                
                <AuthenticatedRoute
                  path="/areariservata/not_allowed"
                  permission='*'
                  component={NotAuthorized}
                />

                {/*
                  ************************************
                  AUTHENTICATION
                  ************************************
                */}
                {/* <UnauthenticatedRoute 
                  path="/signup" 
                  component={Signup} /> */}
                <UnauthenticatedRoute 
                  path="/registrazione" 
                  component={Registrazione} />
                <UnauthenticatedRoute 
                  path="/registrazione" 
                  component={Register} />
                <UnauthenticatedRoute 
                  path="/recover" 
                  component={Recover} />
                <UnauthenticatedRoute 
                  path="/login" 
                  component={Login} />
                <Route 
                  path="/consultala_login" 
                  component={ConsultalaLogin} /> 

                {/*
                  ************************************
                  PIANO BASE
                  ************************************
                */}
                <AuthenticatedRoute 
                  path="/areariservata" 
                  permission='*'  
                  component={Dashboard} />
                <AuthenticatedRoute 
                  path="/areariservata/cedolini" 
                  permission='*'
                  component={() => (
                    <CheckPermissions permissionsToCheck={['hr.view_docs']}>
                      <ArCedolini />
                    </CheckPermissions>
                  )} 
                />
                <AuthenticatedRoute 
                  path="/areariservata/cedolini/:resourceId" 
                  permission='*' 
                  component={ArSingleCedolino} />
                <AuthenticatedRoute 
                  path="/areariservata/cu" 
                  permission='*'
                  component={() => (
                    <CheckPermissions permissionsToCheck={['hr.view_docs']}>
                      <ArCu />
                    </CheckPermissions>
                  )}  
                />
                <AuthenticatedRoute 
                  path="/areariservata/cu/:resourceId" 
                  permission='*' 
                  component={ArSingleCu} />
                <AuthenticatedRoute 
                  path="/areariservata/documenti" 
                  permission='*' 
                  component={() => (
                    <CheckPermissions permissionsToCheck={['hr.view_docs']}>
                      <ArDocuments />
                    </CheckPermissions>
                  )} 
                />
                <AuthenticatedRoute 
                  path="/areariservata/documenti/:resourceId" 
                  permission='*' 
                  component={ArSingleDoc} />
                <AuthenticatedRoute 
                  path="/areariservata/avvisi"
                  permission='alerts' 
                  component={() => (
                    <CheckPermissions permissionsToCheck={['hr.view_shifts']}>
                      <AvvisiComponent />
                    </CheckPermissions>
                  )}
                />
                <AuthenticatedRoute 
                  path="/areariservata/profilo" 
                  permission='*' 
                  component={ProfileEmployee} />
                
                {/*
                  ************************************
                  PRESENZE
                  ************************************
                */}
                <AuthenticatedRoute 
                  path="/areariservata/richiesta" 
                  permission="justifications"
                  component={() => (
                    <CheckPermissions permissionsToCheck={['hr.can_request_justification']}>
                      <ArNewJustificationRequest />
                    </CheckPermissions>
                  )}
                />
                <AuthenticatedRoute 
                  path="/areariservata/turni" 
                  permission='shifts' 
                  component={() => (
                    <CheckPermissions permissionsToCheck={['hr.view_shifts']}>
                      <ArTurni />
                    </CheckPermissions>
                  )}
                />
                <AuthenticatedRoute 
                  path="/areariservata/timbrature" 
                  permission='inoouts' 
                  component={() => (
                    <CheckPermissions permissionsToCheck={['hr.manage_inouts', 'hr.view_inouts']}>
                      <TimbratureDipendente />
                    </CheckPermissions>
                  )}
                />
                {/* <AuthenticatedRoute 
                  path="/areariservata/timbrature" 
                  permission='shifts' 
                  component={() => (
                   
                      <TimbratureDipendente />
                 
                  )}
                /> */}
                <AuthenticatedRoute 
                  path="/areariservata/rimborso_spese"
                  permission='cost_refunds' 
                  component={() => (
                    <CheckPermissions permissionsToCheck={['hr.view_shifts']}>
                      <RimborsoSpese />
                    </CheckPermissions>
                  )}
                />
                <AuthenticatedRoute 
                  path="/areariservata/avvisi/:resourceId/" 
                  permission='alerts' 
                  component={ArSingleMessage} />
                <AuthenticatedRoute 
                  path="/dipendenti/:codiceFiscale" 
                  permission='payrolls' 
                  component={Employee} />
                <AuthenticatedRoute 
                  path="/dipendenti/:codiceFiscale/details" 
                  permission='payrolls' 
                  component={EmployeeDetails} />
                <AuthenticatedRoute 
                  path="/organization" 
                  permission='shifts' 
                  component={() => (
                    <CheckPermissions permissionsToCheck={['hr.manage_shifts_all', 'hr.manage_shifts_ou', 'hr.view_shifts_all', 'hr.view_shifts_ou']}>
                      <OrgTree />
                    </CheckPermissions>
                  )}
                /> 
                <AuthenticatedRoute 
                  path="/organization/new" 
                  permission='shifts' 
                  component={CreateOrgUnitForm} />
                <AuthenticatedRoute 
                  path="/organization/:ou_id" 
                  permission='shifts' 
                  component={DetailOrgUnit} />
                <AuthenticatedRoute 
                  path="/organization/:ou_id/edit" 
                  permission='shifts' 
                  component={OrgEdit} />
                <AuthenticatedRoute 
                  path="/presence" 
                  permission='attendance' 
                  component={Presence} />
                <AuthenticatedRoute 
                  path="/pending_justifications" 
                  permission='justifications'
                  component={() => (
                    <CheckPermissions permissionsToCheck={['hr.manage_justification_all', 'hr.manage_justification_ou']}>
                      <PendingJustifications />
                    </CheckPermissions>
                  )} 
                />
                <AuthenticatedRoute 
                  path="/handled_justifications" 
                  permission='justifications' 
                  component={() => (
                    <CheckPermissions permissionsToCheck={['hr.manage_justification_all', 'hr.manage_justification_ou']}>
                      <HandledJustifications />
                    </CheckPermissions>
                  )} 
                />
                <AuthenticatedRoute 
                  path="/new_justification_request" 
                  permission='justifications'
                  component={() => (
                    <CheckPermissions permissionsToCheck={['hr.manage_justification_all', 'hr.manage_justification_ou']}>
                      <NewJustificationRequest />
                    </CheckPermissions>
                  )}  
                />
                <AuthenticatedRoute 
                  path="/shift_management" 
                  permission='shifts'
                  component={() => (
                    <CheckPermissions permissionsToCheck={['hr.manage_shifts_all', 'hr.manage_shifts_ou', 'hr.view_shifts_all', 'hr.view_shifts_ou']}>
                      <ShiftManagement />
                    </CheckPermissions>
                  )}   
                />
                <AuthenticatedRoute 
                  path="/shift_calendar" 
                  permission='shifts'
                  component={() => (
                    <CheckPermissions permissionsToCheck={['hr.view_shifts_all', 'hr.view_shifts_ou', 'hr.view_attendance_all', 'hr.view_attendance_ou', 'hr.manage_shifts_all', 'hr.manage_shifts_ou']}>
                      <ShiftCalendar />
                    </CheckPermissions>
                  )} 
                />
                <AuthenticatedRoute 
                  path="/in_outs" 
                  permission='shifts'
                  component={() => (
                    <CheckPermissions permissionsToCheck={['hr.view_shifts_all', 'hr.view_shifts_ou', 'hr.view_attendance_all', 'hr.view_attendance_ou', 'hr.manage_shifts_all', 'hr.manage_shifts_ou', 'hr.manage_inouts_ou', 'hr.manage_inouts_all', 'hr.view_inouts_ou', 'hr.view_inouts_all']}>
                      <TimbratureCompanyView />
                    </CheckPermissions>
                  )} 
                />
                <AuthenticatedRoute 
                  path="/assign_working_hour" 
                  permission='shifts'
                  component={() => (
                    <CheckPermissions permissionsToCheck={['hr.manage_shifts_all', 'hr.manage_shifts_ou', 'hr.view_shifts_all', 'hr.view_shifts_ou']}>
                      <TableAssignWh />
                    </CheckPermissions>
                  )}   
                />
                <AuthenticatedRoute 
                  path="/settings_ratei" 
                  permission='shifts' 
                  component={ConfigurazioneParametri} />
                <AuthenticatedRoute 
                  path="/giustificativi_table" 
                  permission='justifications' 
                  component={GiustificativiView} />
                <AuthenticatedRoute 
                  path="/refund_requests" 
                  permission='cost_refunds'
                  component={() => (
                    <CheckPermissions permissionsToCheck={['hr.manage_shifts_all', 'hr.manage_shifts_ou', 'hr.view_shifts_all', 'hr.view_shifts_ou']}>
                      <RimborsoSpeseCompany />
                    </CheckPermissions>
                  )} 
                />
                <AuthenticatedRoute 
                  path="/notice_board" 
                  permission='alerts' 
                  component={() => (
                    <CheckPermissions permissionsToCheck={['hr.manage_shifts_all', 'hr.manage_shifts_ou', 'hr.view_shifts_all', 'hr.view_shifts_ou']}>
                      <BoardMessage />
                    </CheckPermissions>
                  )} 
                />
                <AuthenticatedRoute 
                  path="/statistiche" 
                  permission='attendance'
                  component={() => (
                    <CheckPermissions permissionsToCheck={['hr.manage_justification_all', 'hr.manage_justification_ou', 'hr.manage_shifts_all', 'hr.manage_shifts_ou', 'hr.view_shifts_all', 'hr.view_shifts_ou' ]}>
                      <Statistics />
                    </CheckPermissions>
                  )} 
                />
                <AuthenticatedRoute 
                  path="/dipendenti/:codiceFiscale/upload_busta" 
                  permission='payrolls' 
                  component={UploadSingleBusta} />
                <AuthenticatedRoute 
                  path="/dipendenti/:codiceFiscale/upload_cu" 
                  permission='certification_of_incomes' 
                  component={UploadSingleCu} />
                <AuthenticatedRoute 
                  path="/dipendenti/:codiceFiscale/upload_documento" 
                  permission='documents' 
                  component={UploadSingleDoc} />
                <AuthenticatedRoute 
                  path="/dipendenti" 
                  permission='payrolls' 
                  component={EmployeeList} />
                <AuthenticatedRoute 
                  path="/dipendenti/:codiceFiscale/edit" 
                  permission='*' 
                  component={EditEmployee} />
                <AuthenticatedRoute 
                  path="/nuovo_dipendente" 
                  permission='payrolls' 
                  component={NewEmployee} />
                  <AuthenticatedRoute 
                  path="/upload_csv" 
                  permission='*' 
                  component={UploadCSVEmployee} />
                <AuthenticatedRoute 
                  path="/livelli" 
                  permission='*' 
                  component={canAccessLivelli ? Livelli : NotAuthorized}
                />
                <AuthenticatedRoute 
                  path="/profilo" 
                  permission='*' 
                  component={Profile} />
                <AuthenticatedRoute 
                  path="/profilo/fatturazione" 
                  permission='*' 
                  component={ProfileBilling} />
                <AuthenticatedRoute 
                  path="/:resourceType" 
                  permission='payrolls' 
                  component={ResourceList} />
                <AuthenticatedRoute 
                  path="/:resourceType/:resourceId" 
                  permission='*' 
                  component={ResourceDetail} />
                <AuthenticatedRoute 
                  path="/:resourceType/:resourceId/edit" 
                  permission='*' 
                  component={ComingSoon} />
                
              </Switch>

            </TourProvider>
          </MessageProvider>
        </DataContext.Provider>
      </AuthContext.Provider>  
    </div>
  )
}


Sentry.init({
  dsn: "https://78232d3d0384f980a7ce79ce0821b91a@bugs.montedelgallo.com/api/v1/sentry_errors/3",
  integrations: [
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Profiling
  profilesSampleRate: 1.0, // Profile 100% of the transactions. This value is relative to tracesSampleRate
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  enabled: process.env.NODE_ENV !== 'development',
});



ReactDOM.createRoot(document.getElementById("root") ).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
